import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en'],
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'clientShell',
      'clientProfile',
      'clientDashboard',
      'clientBooking',
      'clientSessions',
      'clientAssessments',
      'clientExercises',
      'clientLibrary',
      'clientPortalHelpline',
      'clientChat',
    ],
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

export default i18n;
